






import Vue from 'vue';

export default Vue.extend({
  name: "PlazaMain2d",
  data: () => {
    return {};
  },
});
